import React, { useEffect, useState } from "react";
import { IoSearch } from "react-icons/io5";
import api from "../../services/api";
import toast from "react-hot-toast";
import DebounceInput from "react-debounce-input";
import { HiMagnifyingGlass } from "react-icons/hi2";
import SelectProject from "../selectProject";
import Loader from "../loader";
import Modal from "../modal";

export default ({ bank, setBank }) => {
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoice] = useState(null);
  const [filters, setFilters] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  useEffect(() => {
    get();
  }, [filters]);

  async function get() {
    setLoading(true);
    const query = {};

    query.received = "no";
    query.sent = "yes";

    if (filters.search) {
      query.search = filters.search;
    }
    if (filters.projectId) {
      query.projectId = filters.projectId;
    }
    const { data } = await api.post(`/invoice/search`, query);
    setInvoice(data);
    setLoading(false);
  }

  const handleAddFilesToBank = async () => {
    if (!selectedInvoice) return;

    const files = [selectedInvoice.file, ...(bank.files || [])];
    const { data } = await api.put(`/bank/${bank._id}`, {
      files,
      status: "DONE",
      projectId: selectedInvoice.projectId,
      projectName: selectedInvoice.projectName,
      month: selectedInvoice.date.slice(0, 7),
      tax: selectedInvoice.taxValue,
    });
    setBank(data);
    setShowModal(false);
    setSelectedInvoice(null);
    toast.success("Files added");
  };

  return (
    <div className="text-sm">
      <div className="relative rounded-md shadow-sm w-full grid grid-cols-2 gap-2">
        <div>
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <HiMagnifyingGlass className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <DebounceInput
            debounceTimeout={300}
            name="search"
            id="search"
            className="block w-full rounded-md border-gray-300 pl-10 focus:border-indigo-500 focus:ring-indigo-500 md:text-sm mb-2"
            placeholder="Search invoice"
            value={filters.search}
            onChange={(e) => {
              e.persist();
              setFilters((f) => ({ ...f, search: e.target.value }));
            }}
          />
        </div>
        <SelectProject value={filters.projectId} onChange={(project) => setFilters((f) => ({ ...f, projectId: project._id }))} />
      </div>
      <div className="overflow-x-auto bg-white mt-2">
        <table className="md:w-full table-auto">
          <thead className="border-t border-b-2	 border-t-[#dee2e6] border-l-0 border-r-0 border-b-[#dee2e6]">
            <tr>
              <th scope="col" className="py-2 px-3 text-left text-sm font-semibold text-gray-900 md:pl-3 pl-0">
                Date
              </th>
              <th scope="col" className="py-2 px-3 text-left text-sm font-semibold text-gray-900 md:pl-3 pl-0">
                Name
              </th>
              <th scope="col" className="py-2 px-3 text-left text-sm font-semibold text-gray-900 md:pl-3 pl-0">
                Total
              </th>
              <th scope="col" className="py-2 px-3 text-left text-sm font-semibold text-gray-900 md:pl-3 pl-0">
                See
              </th>
              <th scope="col" className="py-2 px-3 text-left text-sm font-semibold text-gray-900 md:pl-3 pl-0">
                Match
              </th>
            </tr>
          </thead>
          {loading && (
            <tr>
              <td colSpan="5" className="text-center">
                <Loader />
              </td>
            </tr>
          )}
          {(invoices === null || invoices?.length === 0) && (
            <tr>
              <td colSpan="5" className="text-center py-8 text-gray-500">
                <div className="flex flex-col items-center justify-center">
                  <svg className="w-12 h-12 mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <p className="text-lg font-medium">No Invoices Found</p>
                  <p className="text-sm">Try adjusting your search or filters</p>
                </div>
              </td>
            </tr>
          )}
          <tbody>
            {(invoices || []).map((hit, index) => {
              return (
                <tr key={hit._id} className="hover:bg-[#dee2e6] border-b border-[#dee2e6]">
                  <td className="whitespace-nowrap py-1 px-3 text-sm font-normal text-gray-900 md:pl-3 pl-0">
                    <div>
                      <div>{hit.date.slice(0, 10)}</div>
                      <div className="text-gray-400 text-xs">created at {new Date(hit.date).toLocaleString()}</div>
                    </div>
                  </td>
                  <td className="whitespace-nowrap py-1 px-3 text-sm font-normal text-gray-900 md:pl-3 pl-0">
                    <div>{hit.name}</div>
                  </td>
                  <td className="whitespace-nowrap py-1 px-3 text-sm font-normal text-gray-900 md:pl-3 pl-0">
                    <div>{hit.total}</div>
                  </td>
                  <td className="whitespace-nowrap py-1 px-3 text-sm font-normal text-gray-900 md:pl-3 pl-0">
                    <a href={`/invoice/${hit._id}`} target="_blank">
                      <button className="bg-blue-500 hover:bg-blue-700 text-white my-1 px-1">open</button>
                    </a>
                  </td>
                  <td className="whitespace-nowrap py-1 px-3 text-sm font-normal text-gray-900 md:pl-3 pl-0">
                    {hit.file && (
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white my-1 px-1"
                        onClick={() => {
                          setSelectedInvoice(hit);
                          setShowModal(true);
                        }}>
                        Add files to bank
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ConfirmModal isOpen={showModal} onClose={() => setShowModal(false)} onConfirm={handleAddFilesToBank} bank={bank} selectedInvoice={selectedInvoice} />
    </div>
  );
};

const ConfirmModal = ({ isOpen, onClose, onConfirm, bank, selectedInvoice }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Confirm Action</h3>
        {selectedInvoice && (
          <div className="mb-4">
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="border rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-3">Bank Record</h4>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="text-gray-500">Date:</span> <span className="font-medium">{new Date(bank.date).toLocaleDateString()}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Amount:</span> <span className="font-medium">{bank.amount.toFixed(2)} €</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Description:</span> <span className="font-medium">{bank.description || "N/A"}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Category:</span> <span className="font-medium">{bank.category || "N/A"}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Project:</span> <span className="font-medium">{bank.projectName || "N/A"}</span>
                  </div>
                </div>
              </div>
              <div className="border rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-3">Invoice</h4>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="text-gray-500">Date:</span> <span className="font-medium">{new Date(selectedInvoice.date).toLocaleDateString()}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Amount:</span> <span className="font-medium">{selectedInvoice.total.toFixed(2)} €</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Name:</span> <span className="font-medium">{selectedInvoice.name}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Project:</span> <span className="font-medium">{selectedInvoice.projectName || "N/A"}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Reference:</span> <span className="font-medium">{selectedInvoice.reference || "N/A"}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded" onClick={onClose}>
                Cancel
              </button>
              <button className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded" onClick={onConfirm}>
                Confirm
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};
